import { LogoCollection } from "../components/logo-collection";
import { TestimonialCarousel } from "../components/testimonial-carousel/TestimonialCarousel";

const test = ({
  __typename,
  staticType,
}: {
  __typename: string;
  staticType: string;
}): boolean =>
  __typename === "VinoData_StaticBlock" &&
  staticType === "Whiskymofo Social Proof";

const create = (data: any): JSX.Element => {
  return (
    <>
      <TestimonialCarousel />
      <LogoCollection
        heading="Enjoy exclusive access to insane deals from the most iconic distilleries"
        logoImageUrl="https://res.cloudinary.com/vinomofo/image/upload/v1752447767/Whisky%202.0/Whiskymofo%20Landing/whiskymofo-text-and-logos.png"
      />
    </>
  );
};

export default { test, create };
